import {
    HistoryListElementHistoryElementType,
    HistoryListElementType,
    HistoryListMapType,
    HistorySearchParamType
} from "../interface";
import moment from "moment";

export const historySearchParamInit: HistorySearchParamType = {
    endAt: moment().format("YYYY-MM-DD"),
    keywordType: "0",
    limit: 10,
    pageNo: 1,
    startAt: moment().startOf("months").format("YYYY-MM-DD"),
}

export const historyListElementHistoryElementInit: HistoryListElementHistoryElementType = {
    inventoryChangeId: 0,
    newTxtNmItem: "",
    originalPrice: 0,
    sellingPrice: 0,
    newTxtStndItem: "",
    inventoryUnit: 0,
    category: "",
    safetyAmount: 0,
    changeLog: "",
    changeAmount: 0,
    fileKey: "",
    fileUrl: "",
    fileOrgname: "",
}

export const historyListElementInit: HistoryListElementType = {
    changeType: "",
    recordSize: 0,
    totalChange: 0,
    accountName: "",
    mainItemName: "",
    changeAt: "",
    eachInventoryHistoryList: []
}

export const historyListMapInit: HistoryListMapType = {
    inventoryHistoryResList: [],
    totalCount: 0
}

